import angular from "angular";
import uiRouter from "angular-ui-router";
import eventeditdetailsComponent from "./eventeditdetails.component";

let eventeditdetailsModule = angular
  .module("eventeditdetails", [uiRouter])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";
    $stateProvider.state("eventeditdetails", {
      // url: '/event-edit-details',
      url: "/event/:eventId/edit",
      template: "<eventeditdetails></eventeditdetails>",
      title: "Edit Job",
    });
  })

  .component("eventeditdetails", eventeditdetailsComponent);

export default eventeditdetailsModule;

/*.state('eventeditdetails', {
url: '/event/:eventId/edit/shifts',
template: '<accountprofile></accountprofile>'

})
.state('eventeditdetails', {
url: '/event/:eventId/edit/questions',
template: '<accountprofile></accountprofile>'

})*/



// WEBPACK FOOTER //
// ./client/app/components/eventeditdetails/eventeditdetails.js